import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Helmet } from 'react-helmet-async';
export function DmcaPage() {
  return <>
      <Helmet data-id="element-190">
        <title data-id="element-191">DMCA Policy - Fifth Door</title>
        <meta name="description" content="Fifth Door DMCA Policy." data-id="element-192" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-193" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-194" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-195" />
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-196">
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-197" />
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-198" />

        <div className="absolute top-8 left-8 z-20" data-id="element-199">
          <Link to="/" className="flex items-center gap-3" data-id="element-200">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-201" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-202">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        <div className="relative z-10 px-6 py-20 md:py-32 max-w-4xl mx-auto" data-id="element-203">
          <h1 className="text-[50px] md:text-[74px] mb-8 text-center" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-204">
            DMCA POLICY
          </h1>
          <div className="text-white/70 leading-relaxed text-lg space-y-6" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-205">
            <h2 className="text-2xl font-bold text-white mt-4" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-206">
              NOTIFICATION OF COPYRIGHT INFRINGEMENT
            </h2>

            <p data-id="element-207">
              Fifth Door Inc. ("Fifth Door") respects the intellectual property
              rights of others and expects its users to do the same.
            </p>

            <p data-id="element-208">
              It is Fifth Door's policy, in appropriate circumstances and at its
              discretion, to disable and/or terminate the accounts of users who
              repeatedly infringe or are repeatedly charged with infringing the
              copyrights or other intellectual property rights of others.
            </p>

            <p data-id="element-209">
              In accordance with the Digital Millennium Copyright Act of 1998,
              the text of which may be found on the U.S. Copyright Office
              website at{' '}
              <a href="http://www.copyright.gov/legislation/dmca.pdf" target="_blank" rel="noopener noreferrer" className="text-white underline hover:opacity-80" data-id="element-210">
                http://www.copyright.gov/legislation/dmca.pdf
              </a>
              , Fifth Door will respond expeditiously to claims of copyright
              infringement committed using the Fifth Door website (the "Sites")
              that are reported to Fifth Door's Designated Copyright Agent,
              identified in the sample notice below.
            </p>

            <p data-id="element-211">
              If you are a copyright owner, or are authorized to act on behalf
              of one, or authorized to act under any exclusive right under
              copyright, please report alleged copyright infringements taking
              place on or through the Sites by completing the following DMCA
              Notice of Alleged Infringement and delivering it to Fifth Door's
              Designated Copyright Agent. Upon receipt of the Notice as
              described below, Fifth Door will take whatever action, in its sole
              discretion, it deems appropriate, including removal of the
              challenged material from the Sites.
            </p>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-212">
              DMCA NOTICE OF ALLEGED INFRINGEMENT ("NOTICE")
            </h2>

            <ol className="list-decimal pl-6 space-y-3" data-id="element-213">
              <li data-id="element-214">
                Identify the copyrighted work that you claim has been infringed,
                or — if multiple copyrighted works are covered by this Notice —
                you may provide a representative list of the copyrighted works
                that you claim have been infringed.
              </li>
              <li data-id="element-215">
                Identify the material that you claim is infringing (or to be the
                subject of infringing activity) and that is to be removed or
                access to which is to be disabled, and information reasonably
                sufficient to permit us to locate the material, including at a
                minimum, if applicable, the URL of the link shown on the Site(s)
                where such material may be found.
              </li>
              <li data-id="element-216">
                Provide your mailing address, telephone number, and, if
                available, email address.
              </li>
              <li data-id="element-217">
                Include both of the following statements in the body of the
                Notice:
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-218">
                  "I hereby state that I have a good faith belief that the
                  disputed use of the copyrighted material is not authorized by
                  the copyright owner, its agent, or the law (e.g., as a fair
                  use)."
                </p>
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-219">
                  "I hereby state that the information in this Notice is
                  accurate and, under penalty of perjury, that I am the owner,
                  or authorized to act on behalf of the owner, of the copyright
                  or of an exclusive right under the copyright that is allegedly
                  infringed."
                </p>
              </li>
              <li data-id="element-220">
                Provide your full legal name and your electronic or physical
                signature.
              </li>
            </ol>

            <p data-id="element-221">
              Deliver this Notice, with all items completed, to Fifth Door's
              Designated Copyright Agent:
            </p>

            <div className="border border-white/10 rounded-xl p-6 bg-white/5 space-y-1" data-id="element-222">
              <p className="text-white font-semibold" data-id="element-223">
                Copyright Agent c/o Fifth Door
              </p>
              <p data-id="element-224">
                Email:{' '}
                <a href="mailto:dmca@fifthdoor.com" className="text-white underline hover:opacity-80" data-id="element-225">
                  dmca@fifthdoor.com
                </a>
              </p>
              <p data-id="element-226">2261 Market Street STE 22291, San Francisco, CA 94114</p>
            </div>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-227">
              COUNTER NOTICES
            </h2>

            <p data-id="element-228">
              One who has posted material that allegedly infringes a copyright
              may send Fifth Door a counter notice pursuant to Sections
              512(g)(2) and 512(g)(3) of the DMCA. When Fifth Door receives a
              counter notice, Fifth Door will reinstate the material in question
              in not less than 10 and not more than 14 business days after Fifth
              Door receives the counter notice unless Fifth Door first receives
              notice from the copyright claimant that he/she has filed a legal
              action to restrain the allegedly infringing activity. To provide a
              counter notice to Fifth Door, please return the following form to
              Fifth Door's Designated Copyright Agent. Please note that if you
              provide a counter notice, in accordance with the Fifth Door
              Privacy Policy located at{' '}
              <Link to="/privacy" className="text-white underline hover:opacity-80" data-id="element-229">
                http://play.fifthdoor.com/privacy
              </Link>{' '}
              and the terms of the DMCA, the counter notice will be given to the
              copyright claimant.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-230">
              Counter Notice
            </h3>

            <ol className="list-decimal pl-6 space-y-3" data-id="element-231">
              <li data-id="element-232">
                Identify the material that has been removed or to which access
                has been disabled and the location at which the material
                appeared before it was removed or access to it was disabled.
              </li>
              <li data-id="element-233">
                Provide your mailing address, telephone number, and, if
                available, email address.
              </li>
              <li data-id="element-234">
                Include both of the following statements in the body of the
                Notice:
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-235">
                  "I hereby state under penalty of perjury that I have a good
                  faith belief that the material was removed or disabled as a
                  result of mistake or misidentification of the material to be
                  removed or disabled."
                </p>
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-236">
                  "I hereby state that I consent to the jurisdiction of the
                  Federal District Court for the judicial district in which my
                  address is located or, if my address is outside of the United
                  States, for any judicial district in which Fifth Door may be
                  found, and I will accept service of process from the
                  complaining party who notified Fifth Door of the alleged
                  infringement or an agent of such person."
                </p>
              </li>
              <li data-id="element-237">
                Provide your full legal name and your electronic or physical
                signature.
              </li>
            </ol>

            <p data-id="element-238">
              Deliver this Notice, with all items completed, to Fifth Door's
              Designated Copyright Agent:
            </p>

            <div className="border border-white/10 rounded-xl p-6 bg-white/5 space-y-1" data-id="element-239">
              <p className="text-white font-semibold" data-id="element-240">
                Copyright Agent c/o Fifth Door
              </p>
              <p data-id="element-241">
                Email:{' '}
                <a href="mailto:dmca@fifthdoor.com" className="text-white underline hover:opacity-80" data-id="element-242">
                  dmca@fifthdoor.com
                </a>
              </p>
              <p data-id="element-243">2261 Market Street STE 22291, San Francisco, CA 94114</p>
            </div>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-244">
              NOTIFICATION OF TRADEMARK INFRINGEMENT
            </h2>

            <p data-id="element-245">
              If you believe that your trademark (the "Mark") is being used on
              the Site by a user in a way that constitutes trademark
              infringement, please provide Fifth Door's Designated Copyright
              Agent (specified above) with the following information:
            </p>

            <ol className="list-decimal pl-6 space-y-3" data-id="element-246">
              <li data-id="element-247">
                Your full legal name and your electronic or physical signature.
              </li>
              <li data-id="element-248">
                Information reasonably sufficient to permit Fifth Door to
                contact you or your authorized agent, including a name, mailing
                address, telephone number and, if available, an email address.
              </li>
              <li data-id="element-249">
                Identification of the Mark(s) alleged to have been infringed,
                including (i) for registered Marks, a copy of each relevant
                federal trademark registration certificate or (ii) for common
                law or other Marks, evidence sufficient to establish your
                claimed rights in the Mark, including the nature of your use of
                the Mark, and the time period and geographic area in which the
                Mark has been used by you.
              </li>
              <li data-id="element-250">
                Information reasonably sufficient to permit Fifth Door to
                identify the use being challenged.
              </li>
              <li data-id="element-251">
                Include both of the following statements in the body of the
                Notice:
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-252">
                  "I hereby state that I have not authorized the challenged use,
                  and I have a good-faith belief that the challenged use is not
                  authorized by law."
                </p>
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-253">
                  "I hereby state under penalty of perjury that all of the
                  information in the notification is accurate and that I am the
                  owner of the Mark, or authorized to act on behalf of the owner
                  of the Mark."
                </p>
              </li>
            </ol>

            <p data-id="element-254">
              Upon receipt of notice as described above, Fifth Door will seek to
              confirm the existence of the Mark on the Sites, notify the
              registered user who posted the content including the Mark, and
              take whatever action, in its sole discretion, it deems
              appropriate, including temporary or permanent removal of the Mark
              from the Sites.
            </p>

            <h2 className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-255">
              NOTIFICATION OF OTHER INTELLECTUAL PROPERTY ("IP") INFRINGEMENT
            </h2>

            <p data-id="element-256">
              If you believe that some other IP right of yours is being
              infringed by a user, please provide Fifth Door's Designated
              Copyright Agent (specified above) with the following information:
            </p>

            <ol className="list-decimal pl-6 space-y-3" data-id="element-257">
              <li data-id="element-258">
                Your full legal name and your electronic or physical signature.
              </li>
              <li data-id="element-259">
                Information reasonably sufficient to permit Fifth Door to
                contact you or your authorized agent, including a name, mailing
                address, telephone number and, if available, an email address.
              </li>
              <li data-id="element-260">
                Identification of the IP alleged to have been infringed,
                including (i) a complete description or explanation of the
                nature of the IP, (ii) evidence that you own the IP in the
                relevant jurisdiction, including copies of relevant patents,
                registrations, certifications or other documentary evidence of
                your ownership, and (iii) a showing sufficient for Fifth Door to
                determine without unreasonable effort that the IP has been
                infringed.
              </li>
              <li data-id="element-261">
                Information reasonably sufficient to permit Fifth Door to
                identify the use being challenged.
              </li>
              <li data-id="element-262">
                Include both of the following statements in the body of the
                Notice:
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-263">
                  "I hereby state that I have not authorized the challenged use,
                  and I have a good-faith belief that the challenged use is not
                  authorized by law."
                </p>
                <p className="mt-3 pl-4 border-l-2 border-white/20 italic" data-id="element-264">
                  "I hereby state under penalty of perjury that all of the
                  information in the notification is accurate and that I am the
                  owner of the IP, or authorized to act on behalf of the owner
                  of the IP."
                </p>
              </li>
            </ol>

            <p data-id="element-265">
              Upon receipt of notice as described above, Fifth Door will seek to
              confirm the existence of the IP on the Sites, notify the user who
              posted the content including the IP, and take whatever action, in
              its sole discretion, it deems appropriate, including temporary or
              permanent removal of the IP from the Sites.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-266" />
    </>;
}